<script>
import router from '@/router';
import axios from 'axios';
import PageLoader from '../components/Loader'
import {ErrorMessage, Field, Form} from "vee-validate";

export default {
  data() {
    return {
      phone: "",
      code: "",
      messages: "",
      step: "",
      token: "",
      isloading: false,
      errorMessage:"",
      resendFlag:false,
      time:120,
      timer:null,
    }
  }, components: {
    Form,
    Field,
    ErrorMessage,
    PageLoader
  },
  created() {
    this.phone = this.$route.query.phone;
    if (localStorage.phone) {
      this.phone = localStorage.phone
    }
    this.setTimer()
  },
  methods: {
    isRequired(value) {
      if (value && value.trim()) {
        return true;
      }
      return 'لطفا کد دریافتی را وارد نمایید';
    },
    loginHandle() {
      this.resendFlag=false
      this.time=120
      this.setTimer()
      axios
          .get(process.env.VUE_APP_ROOT_API+'/api/login?phone=' + this.phone)
          .then(response => (this.messages = response.data))
    },
    setTimer(){
      this.timer = setInterval( () => {
						if (this.time > 0) {
							 this.time--
						} else {
              this.time=""
							 clearInterval(this.timer)
							 this.resendFlag=true
						}
				  }, 1000 )
    },
    step2Login() {
      this.isloading = true;
      axios
          .get(process.env.VUE_APP_ROOT_API+'/api/login/step2?phone=' + this.phone + '&code=' + this.code)
          .then(response => {
            this.isloading = false
            this.messages = response.data
            if (this.messages.status === "ok") {
              this.step = this.messages.step;
              localStorage.token = this.messages.token
              localStorage.phone = this.phone
              if (this.step == "2") {
                router.push('/intro')
              } else if (this.step == "3" || this.step == "6") {
                localStorage.name=this.messages.user_name
                router.push('/rule-tutorial')
              } else if (this.step == "4") {
                localStorage.name=this.messages.user_name
                localStorage.score=this.messages.score
                router.push('/final-exam-rule')
              } else {
                localStorage.name=this.messages.user_name
                localStorage.score=this.messages.score
                router.push('/final')
              }
            }else{
              this.isloading = false
              this.errorMessage=this.messages.message
            }
          })
          .catch(err => {
            this.isloading = false
            this.errorMessage=err.response.data.message
          })


    }
  },
}
</script>
<template>
  <PageLoader v-if="isloading"/>
  <h1 class="">ثبت نام اولیه سامانه</h1>
  <div class="m-3">
    <span> کدی که به شماره {{ phone }} ارسال شده را وارد نمایید. </span><br>
    <span class="text-danger mx-auto"><b>{{ errorMessage }}</b></span>
    <Form @submit="onSubmit">
      <Field @keypress.prevent.enter = "step2Login" type="number" v-model="code" class="form-control mt-3" name="reagent_phone"
             placeholder="کد پیامکی" :rules="isRequired"/>
      <ErrorMessage name="reagent_phone"/>
    </Form>
    <div class="row d-flex align-items-end">
      <div class="col-6">
        {{ time }}
        <button type="button" v-if="resendFlag" @click="loginHandle" class="btn btn-success mt-3">ارسال مجدد کد</button>
      </div>
      <div class="col-6 mt-3 text-start ">
        <RouterLink to="/PhoneNumber" class="changePhone">
          اصلاح شماره موبایل
        </RouterLink>
      </div>
    </div>
  </div>
  <br>
  <!--<RouterLink to="/intro" class="bbot mx-auto">
    ورود
  </RouterLink>-->
  <div class="row">
    <div class="col-12 text-center">
      <button @click="step2Login" class="btn btn-success px-4">ورود</button>
    </div>
  </div>
</template>
<style>

</style>

